var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmCancellation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 100,
    viewBox: "0 0 125 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.875 0H19.2578C15.2148 0 11.6406 2.57812 10.3711 6.40625L0.488281 36.0547C0.332031 36.5234 0.332031 37.0117 0.253906 37.5H46.875V0ZM92.8125 15.957L89.6289 6.42578C88.3594 2.57813 84.7852 0 80.7422 0H53.125V30.7422C61.6992 21.4648 73.9062 15.625 87.5 15.625C89.2969 15.625 91.0742 15.7422 92.8125 15.957ZM40.625 62.5C40.625 55.8398 42.0508 49.4922 44.5703 43.75H0V90.625C0 95.8008 4.19922 100 9.375 100H59.4922C48.0664 91.4453 40.625 77.8516 40.625 62.5ZM87.5 25C66.7969 25 50 41.7969 50 62.5C50 83.2031 66.7969 100 87.5 100C108.203 100 125 83.2031 125 62.5C125 41.7969 108.203 25 87.5 25ZM109.785 53.8672L84.1992 79.2578C83.3594 80.0977 81.9922 80.0977 81.1523 79.2383L66.3672 64.3359C65.5273 63.4961 65.5469 62.1289 66.3867 61.2891L71.4648 56.25C72.3047 55.4102 73.6719 55.4297 74.5117 56.2695L82.7344 64.5703L101.719 45.7422C102.559 44.9023 103.926 44.9219 104.766 45.7617L109.805 50.8398C110.625 51.6797 110.625 53.0469 109.785 53.8672Z",
    fill: "#008393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmCancellation);
export default __webpack_public_path__ + "static/media/confirm-cancellation.3f44fd2e34c19c186c4c6e9325cec85c.svg";
export { ForwardRef as ReactComponent };